/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Complete_Address_To_Prefetch_RatesInputs */

const en_orders_complete_address_to_prefetch_rates = /** @type {(inputs: Orders_Complete_Address_To_Prefetch_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete address and shipping date to prefetch rates before apply.`)
};

const es_orders_complete_address_to_prefetch_rates = /** @type {(inputs: Orders_Complete_Address_To_Prefetch_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa direccion y fecha de envio para precargar tarifas antes de aplicar.`)
};

/**
* | output |
* | --- |
* | "Complete address and shipping date to prefetch rates before apply." |
*
* @param {Orders_Complete_Address_To_Prefetch_RatesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_complete_address_to_prefetch_rates = /** @type {((inputs?: Orders_Complete_Address_To_Prefetch_RatesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Complete_Address_To_Prefetch_RatesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_complete_address_to_prefetch_rates(inputs)
	return es_orders_complete_address_to_prefetch_rates(inputs)
});